export const FILTERS = [
  'All ads',
  'Active',
  'Complete',
  'Processing',
  'Pending approval',
  'Ready',
  'Rejected',
  'Awaiting review',
  'Stopped',
];

export const ORDERS = {
  ASC: 'asc',
  DESC: 'desc',
};

export const DEFAULT_PARAMS = {
  activePage: 1,
  offset: 0,
  orderBy: 'start date',
  order: ORDERS.DESC,
  searchWord: '',
  status: '',
};

export const RESET_PARAMS = {
  activePage: DEFAULT_PARAMS.activePage,
  orderBy: DEFAULT_PARAMS.orderBy,
  order: DEFAULT_PARAMS.order,
};



// WEBPACK FOOTER //
// ./src/constants/BrowseAds.js